// src/components/Footer.js
import React from 'react';

import { FiPhone, FiMail } from 'react-icons/fi';
import { MdLocationOn } from 'react-icons/md';
import { BsFillTelephoneFill } from 'react-icons/bs';

import image1 from '../assets/certificate.png';
import image2 from '../assets/BuyNZMade_Logo_Black_Triangle.svg';
import image3 from '../assets/haccp.png';
import image4 from '../assets/MWC_Black_CampaignStamp_English-150x150.png';

function Footer() {
  return (
    <footer className="bg-white text-black">
      {/* 기존 푸터 콘텐츠 */}
      <div className="p-4 flex flex-col sm:flex-row justify-between items-center sm:items-start">
        {/* 왼쪽 영역: 연락처 정보 */}
        <div className="flex-1 max-w-lg ml-0 sm:ml-[100px] flex flex-col justify-center items-center sm:items-start mb-8 sm:mb-0">
          <h2 className="text-xl font-bold mb-4" style={{ fontSize: '80%' }}>
            Contact
          </h2>
          <ul
            className="flex flex-col space-y-[2px] text-center sm:text-left"
            style={{ fontSize: '80%' }}
          >
            <li className="flex items-center gap-3">
              <BsFillTelephoneFill className="text-black w-4 h-4" />
              <span>070 5117 2759</span>
            </li>
            <li className="flex items-center gap-3">
              <FiPhone className="text-black w-4 h-4" />
              <span>+64 21 898 325</span>
            </li>
            <li className="flex items-center gap-3">
              <FiMail className="text-black w-4 h-4" />
              <span>admin@purelifespanworld-korea.com</span>
            </li>
            <li className="flex items-center gap-3">
              <MdLocationOn className="text-black w-4 h-4" />
              <span>2A/89 Ellice Road, Wairau Valley, Auckland, 0629, NZ</span>
            </li>
          </ul>
        </div>

        {/* 오른쪽 영역: 필요 시 추가 콘텐츠 */}
        <div className="flex justify-center mr-0 sm:mr-[100px]">
          {/* 모바일에서는 2x2 그리드, 데스크톱에서는 1x4 그리드 */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <img
              src={image1}
              alt="Certificate of Recognition"
              className="w-24 h-24 object-contain"
            />
            <img
              src={image2}
              alt="Buy NZ Made"
              className="w-24 h-24 object-contain"
            />
            <img
              src={image3}
              alt="HACCP Certificate"
              className="w-24 h-24 object-contain"
            />
            <img
              src={image4}
              alt="Made With Care Campaign"
              className="w-24 h-24 object-contain"
            />
          </div>
        </div>
      </div>

      {/* 카피라이트 섹션 - 별도의 div로 분리 */}
      <div className="border-t border-gray-200 py-2">
        <p className="text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Lifespan NZ & ABI Trading Ltd. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer; // Footer 컴포넌트를 내보냅니다.
